import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getLeadCustomerHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: "lead_customer", ...action.payload }),
    );
    yield put({
      type: types.GET_LEAD_CUSTOMER_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_LEAD_CUSTOMER_ERROR,
      payload,
    });
  }
}

export function* getLeadCustomerWatcherSaga() {
  yield takeLatest(types.GET_LEAD_CUSTOMER_START, getLeadCustomerHandlerSaga);
}

//delete

function* deleteLeadCustomerHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("lead_customer", action.payload),
    );
    yield put({
      type: types.DELETE_LEAD_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_LEAD_CUSTOMER_ERROR,
      payload,
    });
  }
}

export function* deleteLeadCustomerWatcherSaga() {
  yield takeLatest(types.DELETE_LEAD_CUSTOMER_START, deleteLeadCustomerHandlerSaga);
}

//single item

function* getSingleLeadCustomerHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `lead_customer/${action.payload}` }),
    );
    yield put({
      type: types.SINGLE_LEAD_CUSTOMER_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_LEAD_CUSTOMER_ERROR,
      payload,
    });
  }
}

export function* getSingleLeadCustomerWatcherSaga() {
  yield takeLatest(types.SINGLE_LEAD_CUSTOMER_START, getSingleLeadCustomerHandlerSaga);
}

